import React from 'react';
import '../../../../../assets/css/Modal.css'
import {
    Modal,
} from 'react-bootstrap';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AutoSearchPeople from "../../../../../components/auto-search-people";
import ClassRoomController from "../../../../../services/data-declaration/class-room-controller";
import {getSchoolYear, getSchoolYearName} from "../../../../../utils/authority";

class modalEditClass extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            principalId: '',
            principalName: '',
            principalUsername: '',
            reason: '',
            showBlock: true,
            signupInfo: null
        };
    }

    edit = () => {
        let payload = {
            id: this.state.id,
            grade: this.state.grade,
            headTeacherId: this.state.principalId,
            name: this.state.name,
            studyIn: this.state.studyIn,
            studyInMain: this.state.studyInMain,
        }
        ClassRoomController.edit(payload, res => {
            if (res.success) {
                toast.success("Sửa lớp học thành công!", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000
                });
                this.props.onHide();
                this.props.onRefresh()
            } else {
                toast.error("Có lỗi xảy ra!", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000
                });
            }
        })
    }
    UNSAFE_componentWillReceiveProps(nextProps, nextContext){
        if (nextProps.show){
            this.setState({showLoading: true},
                () => this.detail(nextProps.id)
            )
        }
    }
    detail(userId) {
        ClassRoomController.detail(userId, res => {
            if (res.success) {
                let data = res.data;
                this.setState(
                    {
                        id: data.id,
                        name: data.name,
                        grade: data.grade,
                        principalId: data.headTeacherRes?.id,
                        principalName: data.headTeacherRes?.fullName,
                        studyIn: data.studyIn,
                        studyInMain: data.studyInMain,
                    }
                );
            } else {
                toast.error(res.message[0], {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000
                });
            }
        });
    }

    render() {
        const modalProp = {
            show: this.props.show,
            onHideModal: this.props.onHide,
            keyboard: false,
            backdrop: 'static',
        };
        return (
            <div>
                <Modal {...modalProp} dialogClassName="modal-dialog-centered full-width-dialog">
                    <div className="modal-container">
                        <div className="btn-close">
                            <button type="button" className="close" onClick={this.props.onHide}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                    <Modal.Body>
                        <div>
                            <h1 className="text-center" style={{fontSize: 20,}}><b>Thêm mới lớp học </b></h1>
                        </div>
                        <div className='d-flex justify-content-center mt-12 mb-12'>
                            <div className="row">
                                <div className="col-md-6 col-xs-12 d-flex">
                                    <label className="col-4 label-item pl-0">Năm học</label>
                                    <label className="col-4 label-item pl-0">{getSchoolYearName()}</label>
                                </div>
                                <div className="col-6 d-flex mb-4">
                                    <label className="col-5 label-item pl-0">Giáo viên chủ nhiệm<span  style={{color: "red",}}>*</span></label>
                                    <AutoSearchPeople
                                        principalId={this.state.principalId}
                                        principalName={this.state.principalName}
                                        principalUsername={this.state.principalUsername}
                                        onUpdateData={(principalId, principalUsername, principalName) => this.setState({principalId: principalId, principalName: principalName, principalUsername: principalUsername})}
                                    />
                                </div>
                                <div className="col-md-6 col-xs-12 d-flex mb-4">
                                    <label className="col-4 label-item pl-0">Khối</label>
                                    <select
                                        className="form-control kt-input pd-4-input hei-input"
                                        value={this.state.grade}
                                        onChange={(e) => {
                                            this.state.grade = e.target.value;
                                            this.setState({
                                                grade: e.target.value,
                                                inEditing: true
                                            })
                                        }}
                                    >
                                        <option value="">Tất cả</option>
                                        <option value="GRADE_1">Khối 1</option>
                                        <option value="GRADE_2">Khối 2</option>
                                        <option value="GRADE_3">Khối 3</option>
                                        <option value="GRADE_4">Khối 4</option>
                                        <option value="GRADE_5">Khối 5</option>
                                        <option value="GRADE_6">Khối 6</option>
                                        <option value="GRADE_7">Khối 7</option>
                                        <option value="GRADE_8">Khối 8</option>
                                        <option value="GRADE_9">Khối 9</option>
                                        <option value="GRADE_10">Khối 10</option>
                                        <option value="GRADE_11">Khối 11</option>
                                        <option value="GRADE_12">Khối 12</option>
                                    </select>
                                </div>
                                <div className="col-md-6 col-xs-12 d-flex mb-4">
                                    <label className="col-5 label-item pl-0">Tên lớp<span  style={{color: "red",}}>*</span></label>
                                    <input
                                        maxLength={255} type="text"
                                        className="form-control shadow-none"
                                        value={this.state.name}
                                        onChange={(event) => {
                                            this.setState({
                                                name: event.target.value
                                            })
                                        }}
                                    />
                                </div>
                                <div className="col-md-6 col-xs-12 d-flex mb-4">
                                    <label className="col-3 label-item pl-0">Học buổi<span  style={{color: "red",}}>*</span></label>
                                    <div className="col-8 row">
                                        <div className="checkbox clearfix d-flex mb-4" style={{marginRight: 12,}}>
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    onChange={(e) => {
                                                        this.setState({studyIn: "MORNING"});
                                                    }}
                                                    checked={this.state.studyIn=="MORNING"}
                                                />
                                                {' '}
                                                Sáng
                                            </label>
                                        </div>
                                        <div className="checkbox clearfix d-flex mb-4" style={{marginRight: 12,}}>
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    onChange={(e) => {
                                                        const value = "AFTERNOON";
                                                        this.setState({studyIn: "AFTERNOON"});
                                                    }}
                                                    checked={this.state.studyIn=="AFTERNOON"}
                                                />
                                                {' '}
                                                Chiều
                                            </label>
                                        </div>
                                        <div className="checkbox clearfix d-flex mb-4" style={{marginRight: 12,}}>
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    onChange={(e) => {
                                                        const value = "EVENING";
                                                        this.setState({studyIn: "EVENING"});
                                                    }}
                                                    checked={this.state.studyIn=="EVENING"}
                                                />
                                                {' '}
                                                Tối
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 col-xs-12 d-flex mb-4">
                                    <label className="col-4 label-item pl-0">Buổi học chính<span  style={{color: "red",}}>*</span></label>
                                    <div className="col-8 row">
                                        <div className="checkbox clearfix d-flex mb-4" style={{marginRight: 12,}}>
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    onChange={(e) => {
                                                        this.setState({studyInMain: "MORNING"});
                                                    }}
                                                    checked={this.state.studyInMain=="MORNING"}
                                                />
                                                {' '}
                                                Sáng
                                            </label>
                                        </div>
                                        <div className="checkbox clearfix d-flex mb-4" style={{marginRight: 12,}}>
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    onChange={(e) => {
                                                        this.setState({studyInMain: "AFTERNOON"});
                                                    }}
                                                    checked={this.state.studyInMain=="AFTERNOON"}
                                                />
                                                {' '}
                                                Chiều
                                            </label>
                                        </div>
                                        <div className="checkbox clearfix d-flex mb-4" style={{marginRight: 12,}}>
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    onChange={(e) => {
                                                        this.setState({studyInMain: "EVENING"});
                                                    }}
                                                    checked={this.state.studyInMain=="EVENING"}
                                                />
                                                {' '}
                                                Tối
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="d-flex align-right col-md-12 col-xs-12 row">
                            <div className="d-flex justify-content-center align-center mt-3 mb-2 col-md-12 col-xs-12">
                                <button
                                    style={{minWidth: "fit-content", marginRight: "10px"}}
                                    type="button"
                                    className="col-md-2 col-xs-2 border-1-s background-btn w-50 type-button-fix btn btn-primary"
                                    onClick={() => this.edit()}
                                >
                                        <span className='justify-content-center'>
                                            Lưu
                                        </span>
                                </button>
                                <button
                                    style={{minWidth: "fit-content"}}
                                    type="button"
                                    className="col-md-2 col-xs-2 border-1-s w-50 type-button-fix btn btn-secondary"
                                    onClick={this.props.onHide}
                                >
                                        <span className=''>
                                            Hủy
                                        </span>
                                </button>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}

export  default  modalEditClass